var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"learning-timeline"}},[_c('h1',[_vm._v("Learning Timeline")]),_c('div',{staticClass:"timeline-container"},[_c('el-timeline',_vm._l((_vm.items),function(i,index){return _c('div',{key:i.id},[_c('LearningItem',{attrs:{"item":i,"index":index,"itemStatus":_vm.itemStatus,"switchStatus":_vm.switchStatus}})],1)}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }